import { render, staticRenderFns } from "./AnnouncementBar.vue?vue&type=template&id=c96f334a&scoped=true&"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementBar.vue?vue&type=style&index=0&id=c96f334a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96f334a",
  null
  
)

export default component.exports